import { useState } from 'react';
import { FilterPriceRegionModal } from '@/components/Modals/FilterPriceRegionModal';
import { ILocationList } from '@/pages/preco-regiao';
import {
  Box,
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Radio,
} from '@mui/material';

interface ILocationComparativeFilterModalProps {
  isOpen: boolean;
  handleClose: () => void;
  locations: Array<ILocationList & { selected: boolean }>;
  onChangeLocation: (id: number) => void;
}

const LocationComparativeFilterModal = ({
  isOpen,
  handleClose,
  locations,
  onChangeLocation,
}: ILocationComparativeFilterModalProps) => {
  const [search, setSearch] = useState('');
  const [locationSelected, setLocationSelected] = useState(
    locations.find(location => location.selected)?.id as number
  );

  const brazilLocationId = 1;

  return (
    <FilterPriceRegionModal
      title="Localidade"
      inputLabel="Pesquise por localidade"
      open={isOpen}
      handleClose={handleClose}
      selectOption={locationSelected}
      onFilter={value => setSearch(value)}
      setOption={id => onChangeLocation(Number(id))}
    >
      <>
        {locations
          .filter(location =>
            search
              ? location.name.toLowerCase().includes(search.toLowerCase())
              : !search
          )
          .map(location => (
            <Box key={location.id}>
              <ListItem key={location.id} disablePadding>
                <ListItemButton
                  onClick={() => setLocationSelected(location.id)}
                  dense
                >
                  <ListItemIcon>
                    <Radio
                      edge="start"
                      checked={location.id === locationSelected}
                    />
                  </ListItemIcon>
                  <ListItemText primary={location.name} />
                </ListItemButton>
              </ListItem>
              {location.id === brazilLocationId && <Divider />}
            </Box>
          ))}
      </>
    </FilterPriceRegionModal>
  );
};

export default LocationComparativeFilterModal;
export type { ILocationComparativeFilterModalProps };
